export function bbDeepCopy<T>(obj: T): T {
	return JSON.parse(JSON.stringify(obj));
}
